window.cartCache = {
  cartPromise: null,

  getCart() {
    if (this.cartPromise) {
      return this.cartPromise;
    }

    this.cartPromise = window.spark.getCart().catch((e) => {
      this.cartPromise = null;
      throw e;
    });

    return this.cartPromise;
  },

  bust() {
    this.cartPromise = null;
  }
};

document.addEventListener('cart:updated', () => {
  window.cartCache.bust();
});

const mql = window.matchMedia('only screen and (max-width: 768px)');

window.Currency = (function () {

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = format || moneyFormat;

    function formatWithDelimiters(number, precision, thousands, decimal) {
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number === null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        '$1' + thousands
      );
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'");
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

class HTMLUpdateUtility {
  /**
   * Used to swap an HTML node with a new node.
   * The new node is inserted as a previous sibling to the old node, the old node is hidden, and then the old node is removed.
   *
   * The function currently uses a double buffer approach, but this should be replaced by a view transition once it is more widely supported https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API
   */
  static viewTransition(oldNode, newContent, preProcessCallbacks = [], postProcessCallbacks = []) {
    preProcessCallbacks?.forEach((callback) => callback(newContent));

    const newNodeWrapper = document.createElement('div');
    HTMLUpdateUtility.setInnerHTML(newNodeWrapper, newContent.outerHTML);
    const newNode = newNodeWrapper.firstChild;

    // dedupe IDs
    const uniqueKey = Date.now();
    oldNode.querySelectorAll('[id], [form]').forEach((element) => {
      element.id && (element.id = `${element.id}-${uniqueKey}`);
      element.form && element.setAttribute('form', `${element.form.getAttribute('id')}-${uniqueKey}`);
    });

    oldNode.parentNode.insertBefore(newNode, oldNode);
    oldNode.style.display = 'none';

    postProcessCallbacks?.forEach((callback) => callback(newNode));

    setTimeout(() => oldNode.remove(), 500);
  }

  // Sets inner HTML and reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  static setInnerHTML(element, html) {
    element.innerHTML = html;
    element.querySelectorAll('script').forEach((oldScriptTag) => {
      const newScriptTag = document.createElement('script');
      Array.from(oldScriptTag.attributes).forEach((attribute) => {
        newScriptTag.setAttribute(attribute.name, attribute.value);
      });
      newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
      oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
    });
  }
}


function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.select = this.querySelector('select');
    if (this.select) { 
      this.select.addEventListener('change', this.onSelectChange.bind(this));
    }
    if (this.input) {
      this.maxValue = this.input.max;
      this.minValue = this.input.min;
      this.disableButtons();
      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);
    
      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }
    this.changeEvent = new Event('change', { bubbles: true })
    
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );


  }

  onChange(event) {
    this.disableButtons();
  }

  onSelectChange() {
    const selectValue = this.select.options[this.select.selectedIndex].value;
    this.input.value = selectValue;
  }

  

  disableButtons(event) {

    this.currentValue = this.input.value;

    if (this.maxValue == this.currentValue) {
      if(this.querySelector('[name="plus"]')) {
        this.querySelector('[name="plus"]').disabled = true;
      }
    } else {
      if(this.querySelector('[name="plus"]')) {
        this.querySelector('[name="plus"]').disabled = false;
      }
    }

    if (this.minValue == this.currentValue) {
      if(this.querySelector('[name="minus"]')) {
        this.querySelector('[name="minus"]').disabled = true;
      }
    } else {
      if(this.querySelector('[name="minus"]')) {
        this.querySelector('[name="minus"]').disabled = false;
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = form => {
  const obj = {};
  const formData = new FormData(form);

  for (const key of formData.keys()) {
    const regex = /(?:^(properties\[))(.*?)(?:\]$)/;

    if (regex.test(key)) { 
      obj.properties = obj.properties || {};
      obj.properties[regex.exec(key)[2]] = formData.get(key);
    } else {
      obj[key] = formData.get(key);
    }
  }

  return JSON.stringify(obj);
};

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');
    const summaryElements = this.querySelectorAll('summary');
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.button-show-more)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach(element => {
      element.setAttribute('role', 'button');
      element.setAttribute('aria-expanded', false);
      element.setAttribute('aria-controls', element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      if (detailsElement.querySelector('details[open]')) {
        trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      }

      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    document.body.classList.add('menu-is-open');
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      document.body.classList.remove('menu-is-open');

      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}


customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
    this.setVar('loadPage')
  }

  setVar(when) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    this.usps = this.header.querySelector('.announcement-bar');
    if (this.usps) {
      this.uspOffset = this.usps.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height', `${this.usps.offsetHeight}px`);

    } else {
      this.uspOffset = 0;
    }
    var headerPosition = '0';
    if (when == 'loadPage') {
      headerPosition = this.header.offsetHeight + this.uspOffset; 
    } else {
      headerPosition = this.header.getBoundingClientRect().bottom;
    }
    document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(headerPosition - this.borderOffset - this.uspOffset)}px`);
  }

  openMenuDrawer(summaryElement) {
    this.setVar('openMenu');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.buttonList = this.querySelectorAll('button:not([id^="ModalClose-"]):not([data-media-id]):not(.disclosure__button)');
    this.buttonList.forEach(button => {
      button.addEventListener('click', this.hide.bind(this));
    });

    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model, modal-thumbnails')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        if (event.target.nodeName === 'MODAL-POPUP') this.hide();

      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
    setVw();

  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const templateContent = this.querySelector('template').content.cloneNode(true);
      this.setAttribute('loaded', true);
      this.appendChild(templateContent);
  
      // Ensure the media element (video, model-viewer, iframe) gets focus
      const mediaElement = this.querySelector('video, model-viewer, iframe');
      if (mediaElement) {
        mediaElement.focus();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');


    if (!this.slider || !this.nextButton) return;

    this.initPages();

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
    this.setSlideClass();
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }
      }));
      this.setSlideClass();

    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  setSlideClass() {
    if (this.dataset.fade !== 'true') return;
    this.sliderItemsToShow.forEach((item, index) => {
      if (index === this.currentPage - 1) {
        // Make the item active
        item.classList.add('active');
      } else {
        // Temporarily apply fade-out class
        item.classList.add('fade-out');
        
        // Remove active and fade-out classes after transition
        setTimeout(() => {
          item.classList.remove('active', 'fade-out');
        }, 500); // Match this with the CSS transition duration
      }
    });
  }




}

customElements.define('slider-component', SliderComponent);


class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrappers = Array.from(this.querySelectorAll('.slider-buttons'));
    this.enableSliderLooping = true;

    if (!this.sliderControlWrappers.length) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlWrappers.forEach(wrapper => {
      const controlLinks = Array.from(wrapper.querySelectorAll('.slider-counter__link'));
      controlLinks.forEach(link => link.addEventListener('click', event => this.linkToSlide(event, controlLinks)));
    });


    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }


  update() {
    super.update();
    if(!this.sliderControlWrappers) return;
    this.sliderControlWrappers.forEach(wrapper => {
      const controlLinks = Array.from(wrapper.querySelectorAll('.slider-counter__link'));
      controlLinks.forEach(link => {
        
        link.classList.remove('slider-counter__link--active');
        link.removeAttribute('aria-current');
      });

      const activeLink = controlLinks[this.currentPage - 1];
      if (activeLink) {
        activeLink.classList.add('slider-counter__link--active');
        activeLink.setAttribute('aria-current', true);
      }
    });
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    this.play();
  }

  focusInHandling(event) {
      this.pause();
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event, controlLinks) {
    event.preventDefault();
    const targetIndex = controlLinks.indexOf(event.currentTarget);
    if (targetIndex === -1) return;

    const slideScrollPosition =
      this.sliderFirstItemNode.clientWidth * targetIndex;

    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);


class LoopingSlider extends SliderComponent {
  constructor() {
    super();
    
  }


  initPages() {
    this.start = parseInt(this.dataset.start - 1) || 0;
    super.initPages();
  
    // Fix total pages calculation
    this.totalPages = Math.ceil(this.sliderItemsToShow.length / this.slidesPerPage);
  
    this.startAtSlide(this.start);
  
    setTimeout(() => {
      this.slider.style.scrollBehavior = 'smooth';
      this.update(); // Ensure buttons are correctly enabled
    }, 50);
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
  
    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }
  
    if (this.currentPage !== previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', {
        detail: {
          currentPage: this.currentPage,
          currentElement: this.sliderItemsToShow[this.currentPage - 1]
        }
      }));
      this.setSlideClass();
    }
  
    if (this.enableSliderLooping) return;
  
    // Fix: Ensure buttons only disable when truly at the first or last slide
    const atFirstSlide = this.slider.scrollLeft <= 0;
    const atLastSlide = this.slider.scrollLeft >= (this.slider.scrollWidth - this.slider.clientWidth - 1); // Subtract 1 to handle rounding errors
  
    if (atFirstSlide) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }
  
    if (atLastSlide) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  startAtSlide(index) {
    if (this.sliderItemsToShow.length < index) return;
    this.slider.scrollLeft = this.sliderItemsToShow[index - 1].offsetLeft;
    this.currentPage = index;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
    console.log(this.slider.scrollLeft);
  }

  setSlideClass() {
    this.sliderItemsToShow.forEach((item, index) => {
      if (index === this.currentPage - 1) {
        // Make the item active
        item.classList.add('active');
      } else {
          item.classList.remove('active');
      }
    });
  }


}

customElements.define('looping-slider', LoopingSlider);



class VariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('change', (event) => {
      const target = this.getInputForEventTarget(event.target);
      this.updateSelectionMetadata(event);

      publish(PUB_SUB_EVENTS.optionValueSelectionChange, {
        data: {
          event,
          target,
          selectedOptionValues: this.selectedOptionValues,
        },
      });
    });
  }

  updateSelectionMetadata({ target }) {
    const { value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      Array.from(target.options)
        .find((option) => option.getAttribute('selected'))
        .removeAttribute('selected');
      target.selectedOptions[0].setAttribute('selected', 'selected');

      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = target
        .closest('.product-form__input')
        .querySelector('[data-selected-value] > .swatch');
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = target.closest(`.product-form__input`).querySelector('[data-selected-value]');
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  getInputForEventTarget(target) {
    return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
  }

  get selectedOptionValues() {
    return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
      ({ dataset }) => dataset.optionValueId
    );
  }
}

customElements.define('variant-selects', VariantSelects);

class CartAddButton extends HTMLElement {
  constructor() {
    super();
    this.cartNotification = document.querySelector('cart-notification');
    this.cartDrawer = document.querySelector('cart-drawer');
    if(this.cartNotification){
      this.cart = this.cartNotification;
    } else {
      this.cart = this.cartDrawer;
    }
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = document.querySelector('cart-items');
      if (cartItems) {
        cartItems.addProduct(this.dataset.id, 1);
      } else {
        this.addProduct(this.dataset.id, 1);
      }
    });
  }
  addProduct(id, quantity) {
    this.setAttribute('aria-disabled', true);
    this.classList.add('loading');
    //this.querySelector('.loading-overlay__spinner').classList.remove('hidden');
    const body = JSON.stringify({
      id,
      quantity,
      sections: this.cart.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_add_url}`, {...fetchConfig(), ...{ body }})
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        this.handleErrorMessage(response.description);
        return;
      }

      this.cart.renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    })
    .finally(() => {
      this.classList.remove('loading');
      this.removeAttribute('aria-disabled');
      this.querySelector('.loading-overlay__spinner').classList.add('hidden');
    });
  }
}
customElements.define('cart-add-button', CartAddButton);





class FaqSection extends HTMLElement {
  constructor() {
    super();

    this.detailList = this.querySelectorAll('details');
    this.detailList.forEach(
      (detail) => detail.addEventListener('toggle', this.onDetailToggle.bind(this))
    );

    if (this.dataset.showButtons) {
        this.buttonContainer = this.querySelector('.faq-buttons');
        this.groups = Array.from(this.querySelectorAll('faq-group'));
        if (this.buttonContainer) {
          this.initButtons();
        }
    } else {
        const firstGroup = this.querySelector('faq-group');
        if (firstGroup) {
          firstGroup.classList.add('is-active');
        }
    }
    
    this.openActiveElement();
  }

  initButtons() {
    const template = this.querySelector('#faq-button-template');
    if (!template) return;

    this.groups.forEach((group) => {
      const titleElement = group.querySelector('h2');
      if (!titleElement) {
        return;
      }

      const buttonClone = template.content.cloneNode(true);
      const button = buttonClone.querySelector('button');

      button.textContent = titleElement.textContent;
      button.dataset.expand = group.dataset.groupId;
      button.addEventListener('click', () => {
        this.activateGroup(group);
        if (this.dataset.showButtons && group.dataset.groupId) {
          window.history.replaceState({}, '', `${this.dataset.url}#${group.dataset.groupId}`);
          group.scrollIntoView({ behavior: 'smooth' });
        }
      });

      this.buttonContainer.appendChild(buttonClone);
      // titleElement.classList.add('hidden');
    });

    const observerOptions = {
      root: null,
      rootMargin: '-33% 0px -33% 0px',
      threshold: 0,
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const group = entry.target;
          this.activateGroup(group);
        }
      });
    }, observerOptions);

    this.groups.forEach((group) => {
      observer.observe(group);
    });
  }

  activateGroup(groupToActivate) {
    if (!groupToActivate || groupToActivate.classList.contains('is-active')) return;

    this.groups.forEach((group) => group.classList.remove('is-active'));
    groupToActivate.classList.add('is-active');

    if (this.buttonContainer) {
      this.buttonContainer.querySelectorAll('button').forEach((button) => {
        button.classList.remove('is-active');
      });

      const activeButton = this.buttonContainer.querySelector(`button[data-expand="${groupToActivate.dataset.groupId}"]`);
      if (activeButton) {
        activeButton.classList.add('is-active');
      }
    }
  }

  onDetailToggle(event) {
    if (!event.target.dataset.link) return;
    this.activeElement = event.target.dataset.link;
    window.history.replaceState({}, '', `${this.dataset.url}#${this.activeElement}`);
  }

  openActiveElement() {
    const hash = window.location.hash;
    if (!hash) {
      return;
    }

    const hashValue = hash.substring(1);
    const detail = this.querySelector(`details[data-link="${hashValue}"]`);

    if (detail) {
      const groupToActivate = detail.closest('faq-group');
      if (this.dataset.showButtons) {
        this.activateGroup(groupToActivate);
      }

      setTimeout(() => {
        detail.open = true;
        detail.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else if (this.dataset.showButtons && this.groups) {
      const groupToActivate = this.groups.find((group) => group.dataset.groupId === hashValue);

      if (groupToActivate) {
        this.activateGroup(groupToActivate);

        setTimeout(() => {
          groupToActivate.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    }
  }
}

customElements.define('faq-section', FaqSection);

class ModalPopup extends ModalDialog {
  constructor() {
    super();

    this.timeOut = this.dataset.start;
    this.testMode = this.dataset.test;
    this.cookieName = this.dataset.cookie;

    if (this.testMode) {
      this.show();
    }

    if(localStorage.getItem(this.cookieName) === 'true') return;

    this.init.bind(this)();
    
  }

  init() {
    setTimeout(function(){ this.show() }.bind(this), this.timeOut);
  }

  show() {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    if(this.dataset.blockScrolling) {
      document.body.classList.add('overflow-hidden');
    }
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));    localStorage.setItem(this.cookieName, true);
  }
}
customElements.define('modal-popup', ModalPopup);

class FooterBlock extends HTMLElement {
  constructor(){
    super();
    this.summary = this.querySelector('summary');
    if (!this.summary) return;
    this.details = this.querySelector('details');
    this.init();

    this.summary.addEventListener('click', this.onSummaryClick.bind(this));

    
    
    mql.addEventListener('change', this.init.bind(this));
    
  }
  
  init() {
    if (mql.matches) {
      this.details.open = false;
    } else {
      this.details.open = true;
    }
  }

  onSummaryClick(event) {
    if (!mql.matches) {
      event.preventDefault();
    }
  }

}

customElements.define('footer-block', FooterBlock);



class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
      button: this.querySelector('button'),
      panel: this.querySelector('.disclosure__list-wrapper'),
    };
    if (this.elements.button) {
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
    }
    this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
    this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
  }

  hidePanel() {
    this.elements.button.setAttribute('aria-expanded', 'false');
    this.elements.panel.setAttribute('hidden', true);
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector('form');
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    this.elements.button.focus();
    this.elements.panel.toggleAttribute('hidden');
    this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    this.closest('.shopify-section').classList.add('locale-selector--open');
  }

  closeSelector(event) {
    const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
      this.closest('.shopify-section').classList.remove('locale-selector--open');
    }
  }
}

customElements.define('localization-form', LocalizationForm);

function setVw() {
  let vw = document.documentElement.clientWidth / 100;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}

setVw();
window.addEventListener('resize', setVw);


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('.product-recommendations__inner') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.video = this.querySelector('video');
    this.muteToggle = this.querySelector('button');

    if (!this.video || !this.muteToggle) {
      console.error('VideoPlayer: Missing required video or button element.');
      return;
    }

    this.muteToggle.addEventListener('click', this.onMuteToggleClick.bind(this));
    this.updateButtonState();
  }

  isMuted() {
    return this.video.muted;
  }

  onMuteToggleClick(event) {
    event.preventDefault();
    this.toggleMute();
  }

  toggleMute() {
    this.video.muted = !this.video.muted;
    this.updateButtonState();
  }

  updateButtonState() {
    const isMuted = this.isMuted();

    if (isMuted) {
      this.muteToggle.classList.add('muted');
      this.muteToggle.classList.remove('unmuted');
    } else {
      this.muteToggle.classList.add('unmuted');
      this.muteToggle.classList.remove('muted');
    }
  }
}

customElements.define('video-player', VideoPlayer);

class MegaMenu extends HTMLElement {
  constructor() {
    super();
    this.closeTimeouts = new Map(); // Store timeouts for delayed closing
  }

  connectedCallback() {
    // Listen to the details element's toggle event
    this.parentDetails = this.closest('details.header__menu-large');
    if (this.parentDetails) {
      this.parentDetails.addEventListener('toggle', this.handleDetailsToggle.bind(this));
    }

    // Add hover event listeners for images inside <a> tags
    this.querySelectorAll('.header__menu-item:has(> .media-hovers)').forEach(item => {
      item.addEventListener('mouseover', this.handleImageHover.bind(this));
      item.addEventListener('mouseout', this.handleImageMouseOut.bind(this));
    });
  }

  disconnectedCallback() {
    if (this.parentDetails) {
      this.parentDetails.removeEventListener('toggle', this.handleDetailsToggle.bind(this));
    }
  }

  handleDetailsToggle(event) {
    const stickyHeader = document.querySelector('sticky-header');
    if (!stickyHeader) return;

    const isOpen = event.target.open;
    const colorScheme = this.getAttribute('data-color-scheme');
    const originalColorScheme = stickyHeader.getAttribute('data-color-scheme');

    this.updateColorScheme(stickyHeader, isOpen, colorScheme, originalColorScheme);
  }

  updateColorScheme(stickyHeader, isOpen, colorScheme, originalColorScheme) {
    if (isOpen && colorScheme) {
      if (!stickyHeader.dataset.originalColorScheme) {
        stickyHeader.dataset.originalColorScheme = originalColorScheme;
      }
      stickyHeader.setAttribute('data-color-scheme', colorScheme);
      stickyHeader.classList.add(colorScheme);
    } else {
      const originalScheme = stickyHeader.dataset.originalColorScheme || originalColorScheme;
      if (originalScheme) {
        stickyHeader.setAttribute('data-color-scheme', originalScheme);
        stickyHeader.classList.remove(colorScheme);
        if (originalScheme !== colorScheme) {
          stickyHeader.classList.add(originalScheme);
        }
      }
    }
  }



  handleImageHover(event) {
    const mediaHoversElement = event.currentTarget.querySelector('.media-hovers');
    const submenuImageContainer = this.querySelector('.header__submenu-image');

    if (!mediaHoversElement || !submenuImageContainer) return;

    if (!this.originalContent) {
      this.originalContent = submenuImageContainer.innerHTML;
    }

    // Get the innerHTML of the media-hovers element
    const hoverContent = mediaHoversElement.innerHTML;
    
    if (hoverContent) {
      submenuImageContainer.innerHTML = hoverContent;
    }
  }

  handleImageMouseOut(event) {
    const submenuImageContainer = this.querySelector('.header__submenu-image');

    if (!submenuImageContainer) return;

    if (this.originalContent) {
      submenuImageContainer.innerHTML = this.originalContent;
    }
  }
}

customElements.define('mega-menu', MegaMenu);

class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.targetTime = new Date(this.getAttribute("data-data"));
    this.displayElement = this.querySelector(".countdown-timer__time");
    this.timerInterval = null;
  }

  connectedCallback() {
    if (!this.displayElement || isNaN(this.targetTime.getTime())) {
      console.error("Invalid target time or missing .countdown-timer__time element.");
      this.hideElement();
      return;
    }

    const now = new Date();
    if (this.targetTime <= now) {
      this.hideElement();
      return;
    }

    this.startCountdown();
  }

  disconnectedCallback() {
    this.stopCountdown();
  }

  startCountdown() {
    this.updateTimer();
    this.timerInterval = setInterval(() => this.updateTimer(), 1000);
  }

  stopCountdown() {
    this.hideElement();
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = null;
    }
  }

  updateTimer() {
    const now = new Date();
    let remainingTime = Math.max(0, Math.floor((this.targetTime - now) / 1000));

    if (remainingTime <= 0) {
      this.stopCountdown();
      return;
    }

    const hours = Math.floor(remainingTime / 3600);
    remainingTime %= 3600;
    const minutes = Math.floor(remainingTime / 60);
    const seconds = remainingTime % 60;

    this.displayElement.textContent = `${this.formatTime(hours)}:${this.formatTime(minutes)}:${this.formatTime(seconds)}`;
  }

  hideElement() {
    this.classList.add('hidden');
  }

  formatTime(value) {
    return value.toString().padStart(2, "0");
  }
}

customElements.define("countdown-timer", CountdownTimer);

class BackButton extends HTMLElement {
  connectedCallback() {
    this.checkReferrerDomain();
  }

  checkReferrerDomain() {
      const referrer = document.referrer;
      const currentDomain = window.location.hostname;

    if (referrer) {
          const referrerDomain = new URL(referrer).hostname;

          if (referrerDomain !== currentDomain) {
              this.classList.add('hidden');
          }
    } else {
      this.classList.add('hidden');
      }
  }
}

customElements.define('back-button', BackButton);

class StickyForm extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button[type="submit"]');
    // this.button.addEventListener('click', this.onButtonClick.bind(this));

  }

  connectedCallback() {
    if (!this.moved) {
      this.moved = true;
      // this.closest('.shopify-section').appendChild(this);
    }
    

    this.productFormButton = document.querySelector('product-info .product-form__buttons');
    this.headerBounds = {};
    this.currentScrollTop = 0;
    this.preventReveal = false;

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => this.preventReveal = true;

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
    this.form = document.querySelector('product-form');
    


    this.createObserver();
  }
  onButtonClick(e) {
    e.preventDefault();
    this.productForm = document.querySelector('product-info product-form');
    this.form = document.querySelector('product-info form');
    this.productForm.onSubmitHandler(e);
  }

  disconnectedCallback() {
    this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.removeEventListener('scroll', this.onScrollHandler);
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect;
      observer.disconnect();
    });

    observer.observe(this.productFormButton);
  }

  isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return (
        bounding.top >= 0 &&
        bounding.left >= 0 &&
        bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (!this.preventReveal) {

      if (this.isInViewport(this.productFormButton)) {
        requestAnimationFrame(this.hideForm.bind(this));
      } else {
        requestAnimationFrame(this.revealForm.bind(this));
      }
      if (this.isInViewport(document.querySelector('footer .footer__content-bottom'))) {
        requestAnimationFrame(this.hideForm.bind(this));
      }
      
    } else {
      window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

    }
    return false;

    if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
      requestAnimationFrame(this.hide.bind(this));
    } else if (scrollTop < this.currentScrollTop && scrollTop + window.innerHeight > this.headerBounds.bottom ) {
      if (!this.preventReveal) {
        requestAnimationFrame(this.reveal.bind(this));
      } else {
        window.clearTimeout(this.isScrolling);

        this.isScrolling = setTimeout(() => {
          this.preventReveal = false;
        }, 66);

        requestAnimationFrame(this.hide.bind(this));
      }
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this));
    }


    this.currentScrollTop = scrollTop;
  }

  hideForm() {
    this.classList.add('sticky-form-hidden');
    this.classList.remove('sticky-form-sticky');

  }

  revealForm() {
    this.classList.add('sticky-form-sticky', 'animate');
    this.classList.remove('sticky-form-hidden');
  }

  reset() {
    this.classList.remove('sticky-form-hidden', 'sticky-form-sticky', 'animate');
  }

}

customElements.define('sticky-form', StickyForm);

class ProductVariant extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('mouseenter', this.handleMouseEnter);
    this.addEventListener('mouseleave', this.handleMouseLeave);
    this.variantLabel = this.closest('product-variants').querySelector('.variant-label');
    this.variantTitle = this.dataset.title;
    this.originalVariantLabel = this.variantLabel.dataset.originalTitle;
    this.productForm = this.closest('.card-wrapper').querySelector('product-form');
    if (this.productForm) {
      this.originalProductFormVariantId = this.productForm.querySelector('[name="id"]').value;
    }
    
  }

  handleMouseEnter() {
    const newImage = this.querySelector('img');
    const cardWrapper = this.closest('.card-wrapper');
    if (!cardWrapper) return;
    const mediaElement = cardWrapper.querySelector('media-gallery .media');
    if (newImage && mediaElement) {
      // Store the original image HTML if not already stored
      if (!mediaElement.dataset.originalImg) {
        mediaElement.dataset.originalImg = mediaElement.innerHTML;
      }
      // Replace the existing image with the new image
      mediaElement.innerHTML = '';
      mediaElement.appendChild(newImage.cloneNode(true));
    }

    if (this.variantLabel) {
      this.variantLabel.textContent = this.variantTitle;
    }

    if (this.dataset.available == 'true') {
      this.updateForm(this.dataset.variant, true);
    } else {
      this.updateForm(this.dataset.variant, false);

    }


  }

  handleMouseLeave() {
    return false;
    const cardWrapper = this.closest('.card-wrapper');
    if (!cardWrapper) return;
    const mediaElement = cardWrapper.querySelector('.media-gallery .media');
    if (mediaElement && mediaElement.dataset.originalImg) {
      // Restore the original image HTML
      mediaElement.innerHTML = mediaElement.dataset.originalImg;
    }

    if (this.variantLabel) {
      this.variantLabel.textContent = this.originalVariantLabel;
    }

    this.updateForm(this.originalProductFormVariantId);
  }

  updateForm(variantId, available = true) {
    if(!this.productForm) return;
    this.productForm.querySelector('[name="id"]').value = variantId;
    this.productForm.querySelector('button[type="submit"]').disabled = !available;
    this.productForm.querySelector('button[type="submit"]').textContent = available ? window.variantStrings.add : window.variantStrings.soldOut;
  }
}

// Define the custom element
customElements.define('product-variant', ProductVariant);

class CollectionGrid extends HTMLElement {
  connectedCallback() {
    this.ul = this.querySelector('#product-grid');
    if (!this.ul) return;

    this.items = Array.from(this.ul.children).filter(el =>
      el.classList.contains('product-card')
    );

    this.applyCornerRadii();

    this.debouncedApply = this.debounce(() => this.applyCornerRadii(), 100);

    // ResizeObserver for grid layout changes
    this.resizeObserver = new ResizeObserver(this.debouncedApply);
    this.resizeObserver.observe(this.ul);

    // Also listen to viewport changes (like resizing columns)
    window.addEventListener('resize', this.debouncedApply);
  }

  disconnectedCallback() {
    this.resizeObserver?.disconnect();
    window.removeEventListener('resize', this.debouncedApply);
  }

  applyCornerRadii() {
    const items = this.items;
    if (!items.length) return;
  
    const rects = items.map(el => ({
      el,
      rect: el.getBoundingClientRect()
    }));
  
    const top = Math.min(...rects.map(i => i.rect.top));
    const bottom = Math.max(...rects.map(i => i.rect.bottom));
    const left = Math.min(...rects.map(i => i.rect.left));
    const right = Math.max(...rects.map(i => i.rect.right));
    const TOL = 2;
  
    // Clear previous values
    for (const { el } of rects) {
      el.style.removeProperty('--radius-top-left');
      el.style.removeProperty('--radius-top-right');
      el.style.removeProperty('--radius-bottom-left');
      el.style.removeProperty('--radius-bottom-right');
    }
  
    for (const { el, rect } of rects) {
      const isTop = Math.abs(rect.top - top) < TOL;
      const isBottom = Math.abs(rect.bottom - bottom) < TOL;
      const isLeft = Math.abs(rect.left - left) < TOL;
      const isRight = Math.abs(rect.right - right) < TOL;
  
      if (isTop && isLeft) el.style.setProperty('--radius-top-left', 'var(--border-radius)');
      if (isTop && isRight) el.style.setProperty('--radius-top-right', 'var(--border-radius)');
      if (isBottom && isLeft) el.style.setProperty('--radius-bottom-left', 'var(--border-radius)');
      if (isBottom && isRight) el.style.setProperty('--radius-bottom-right', 'var(--border-radius)');
    }
  
    // ✅ Always apply bottom-right radius to last visible item
    const last = rects.at(-1);
    if (last) {
      last.el.style.setProperty('--radius-bottom-right', 'var(--border-radius)');
    }
  
    // ✅ Edge case: bottom-right corner if no item below
    const groupedByTop = new Map();
    for (const item of rects) {
      const rowTop = [...groupedByTop.keys()].find(key => Math.abs(key - item.rect.top) < TOL) ?? item.rect.top;
      if (!groupedByTop.has(rowTop)) groupedByTop.set(rowTop, []);
      groupedByTop.get(rowTop).push(item);
    }
  
    const sortedRows = [...groupedByTop.entries()].sort((a, b) => a[0] - b[0]);
  
    if (sortedRows.length >= 2) {
      const [secondToLastRowTop, secondToLastItems] = sortedRows.at(-2);
      const [lastRowTop, lastRowItems] = sortedRows.at(-1);
  
      // Find right-most item in the second-to-last row
      const secondToLastRightmost = secondToLastItems.reduce((rightmost, item) =>
        item.rect.right > rightmost.rect.right ? item : rightmost
      );
  
      const { rect } = secondToLastRightmost;
  
      const hasItemBelow = lastRowItems.some(below =>
        Math.abs(below.rect.left - rect.left) < TOL ||
        (below.rect.left < rect.right && below.rect.right > rect.left)
      );
  
      if (!hasItemBelow) {
        secondToLastRightmost.el.style.setProperty('--radius-bottom-right', '.8rem');
      }
    }
  }

  debounce(fn, delay = 100) {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => fn.apply(this, args), delay);
    };
  }
}

customElements.define('collection-grid', CollectionGrid);


class ScrollDownButton extends HTMLElement {
  constructor() {
    super();
    this.onClick = this.onClick.bind(this);
  }

  connectedCallback() {
    this.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
  }

  onClick(event) {
    event.preventDefault();

    const currentSection = this.closest('.shopify-section');
    const sections = Array.from(document.querySelectorAll('.shopify-section'));

    let nextSection = null;
    if (currentSection) {
      const index = sections.indexOf(currentSection);
      if (index > -1) nextSection = sections.slice(index + 1).find(s => s);
    }

    if (!nextSection) return;

    const targetTop = nextSection.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: Math.max(0, targetTop), behavior: 'smooth' });
  }
}

customElements.define('scroll-down-button', ScrollDownButton);

class RteExpandable extends HTMLElement {
  constructor() {
    super();
    this.button = this.nextElementSibling;
    this.button.setAttribute('aria-expanded', 'false');

    this.button.addEventListener('click', this.toggle.bind(this));
    
    // Check if content needs the expand/collapse functionality
    this.checkContentHeight();
  }

  checkContentHeight() {
    // Temporarily remove the line-clamp to measure full height
    const originalStyle = this.style.cssText;
    this.style.cssText = '';
    
    const fullHeight = this.scrollHeight;
    
    // Restore original style
    this.style.cssText = originalStyle;
    
    // Get the collapsed height (5 lines as per CSS)
    const lineHeight = parseFloat(getComputedStyle(this).lineHeight);
    const collapsedHeight = lineHeight * 5;
    
    // Hide button if content doesn't exceed collapsed height
    if (fullHeight <= collapsedHeight) {
      this.button.style.display = 'none';
    }
  }

  toggle() {
    const isExpanded = this.classList.toggle('expanded');
    this.button.setAttribute('aria-expanded', isExpanded.toString());

    if (!isExpanded) {
      const headerOffset = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-bottom-position')) || 0;
      const elementPosition = this.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;
      
      window.scrollTo({
        top: offsetPosition
      });
    }
  }
}

customElements.define('rte-expandable', RteExpandable);

class ReserveForm extends HTMLElement {
  constructor() {
    super();
    this.productId = this.getAttribute('data-product-id');
    this.productSku = this.getAttribute('data-product-sku');
    this.initFormPopulation();
  }

  initFormPopulation() {
    // Function to populate the product field in the shadow DOM
    const populateProductField = () => {
      // Find the shopify-forms-embed element within this reserve-form
      const embedElement = this.querySelector('shopify-forms-embed');
      if (!embedElement) return;

      // Access the shadow root
      const shadowRoot = embedElement.shadowRoot;
      if (!shadowRoot) return;

      // Find the product field inside the shadow DOM
      const productField = shadowRoot.querySelector('input[id="custom#product"]');
      if (productField && this.productId) {
        // Set the value to the product variant ID
        productField.value = this.productId;
        
        // Hide the product field and its container
        const productFieldContainer = productField.closest('._formFieldContainer_1mxsl_5');
        if (productFieldContainer) {
          productFieldContainer.style.display = 'none';
        }
        
        // Apply font-variation-settings to all inputs, labels, and buttons
        const inputs = shadowRoot.querySelectorAll('input, textarea, select');
        const labels = shadowRoot.querySelectorAll('label');
        const buttons = shadowRoot.querySelectorAll('button[type="submit"]');
        
        [...inputs, ...labels].forEach(element => {
          element.style.fontVariationSettings = "'wght' 300, 'wdth' 90";
        });
        
        // Apply additional styles to buttons
        buttons.forEach(button => {
          button.style.textTransform = 'uppercase';
          button.style.justifyContent = 'start';
          button.style.fontSize = '1.8rem';
          button.style.fontVariationSettings = "'wght' 500, 'wdth' 67.5";
          button.style.maxWidth = 'fit-content';
        });
        
        // Trigger events to ensure the form recognizes the change
        productField.dispatchEvent(new Event('input', { bubbles: true }));
        productField.dispatchEvent(new Event('change', { bubbles: true }));
        
        console.log('Product field populated with variant ID:', this.productId);
      } else {
        console.log('Product field not found or no product ID available');
      }

      // Find and populate the SKU field inside the shadow DOM
      const skuField = shadowRoot.querySelector('input[id="custom#sku"]');
      if (skuField && this.productSku) {
        skuField.value = this.productSku;

        // Hide the SKU field and its container
        const skuFieldContainer = skuField.closest('._formFieldContainer_1mxsl_5');
        if (skuFieldContainer) {
          skuFieldContainer.style.display = 'none';
        }

        // Trigger events to ensure the form recognizes the change
        skuField.dispatchEvent(new Event('input', { bubbles: true }));
        skuField.dispatchEvent(new Event('change', { bubbles: true }));

        console.log('SKU field populated with:', this.productSku);
      } else {
        console.log('SKU field not found or no product SKU available');
      }
    };

    // Try to populate immediately
    setTimeout(populateProductField, 1000);

    // Also try after a longer delay in case the form loads later
    setTimeout(populateProductField, 3000);

    // Watch for changes in the shadow DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length > 0) {
          populateProductField();
        }
      });
    });

    // Observe the embed element for changes
    const embedElement = this.querySelector('shopify-forms-embed');
    if (embedElement) {
      observer.observe(embedElement, { childList: true, subtree: true });
    }

    // Clear observer after 10 seconds
    setTimeout(() => observer.disconnect(), 10000);
  }
}

// Register the custom element
customElements.define('reserve-form', ReserveForm);
